module.exports = __webpack_public_path__ + "img/feconomicos.b5cece75.png";